import { render, staticRenderFns } from "./courseTop.vue?vue&type=template&id=61a70af6&scoped=true"
import script from "./courseTop.vue?vue&type=script&lang=js"
export * from "./courseTop.vue?vue&type=script&lang=js"
import style0 from "./courseTop.vue?vue&type=style&index=0&id=61a70af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a70af6",
  null
  
)

export default component.exports